import axios from "axios";

// 创建axios实例
export default  axios.create({
    // baseURL: 'http://127.0.0.1:9999', // api的base_url
    baseURL: '', // api的base_url
    timeout: 5000, // 请求超时时间
    withCredentials: true
});

